import {graphqlQuery} from '@nlabs/rip-hunter';

import {getApiUrl} from './workspaceEnvironment.js';

type AnalyticsConfigurationResponse = Readonly<{
  readonly analytics?: {
    readonly configuration?: {
      readonly analyticsId?: string;
    } | null;
  };
}>;

const ANALYTICS_CONFIGURATION_QUERY = `
  query AnalyticsConfiguration($appId: ID!) {
    analytics {
      configuration(appId: $appId) {
        analyticsId
      }
    }
  }
`;

export const getWorkspaceAnalyticsId = async (appId: string): Promise<string | undefined> => {
  try {
    const response = await graphqlQuery(getApiUrl(), {
      query: ANALYTICS_CONFIGURATION_QUERY,
      variables: {appId}
    }) as AnalyticsConfigurationResponse;
    const analyticsId = response.analytics?.configuration?.analyticsId?.trim();

    return analyticsId || undefined;
  } catch {
    return undefined;
  }
};
